import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./en";
import tr from "./tr";

const geoDetector = {
  name: "geoIp",
  lookup() {
    return undefined;
  },
  cacheUserLanguage() {},
};

/** Supports hreflang alternate `?lang=tr` / `?lang=en` for crawlers and shared links. */
const queryLangDetector = {
  name: "queryLang",
  lookup() {
    if (typeof window === "undefined") return undefined;
    const q = new URLSearchParams(window.location.search).get("lang");
    if (q === "tr" || q === "en") return q;
    return undefined;
  },
  cacheUserLanguage() {},
};

const languageDetector = new LanguageDetector();
languageDetector.addDetector(geoDetector);
languageDetector.addDetector(queryLangDetector);

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources: { en: { translation: en }, tr: { translation: tr } },
    fallbackLng: "en",
    supportedLngs: ["en", "tr"],
    load: "languageOnly",
    detection: {
      order: ["queryLang", "localStorage", "navigator"],
      caches: ["localStorage"],
    },
    interpolation: { escapeValue: false },
    showSupportNotice: false,
  });

const isPrerender =
  typeof navigator !== "undefined" && navigator.webdriver === true;

if (!isPrerender && !localStorage.getItem("i18nextLng")) {
  fetch("https://ipapi.co/json/", { signal: AbortSignal.timeout(3000) })
    .then((r) => r.json())
    .then((data) => {
      if (data?.country_code === "TR" && !localStorage.getItem("i18nextLng")) {
        i18n.changeLanguage("tr");
      }
    })
    .catch(() => {});
}

export default i18n;
